import axios from "axios";
import React, { useState } from "react";
import { Check, X } from "react-feather";
import Modal from "react-modal";
import { useNavigate } from "react-router";
import { useCartorio } from "../../../Hooks/cartorio";
import { useFuncionarioCartorio } from "../../../Hooks/funcionarioCartorio";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import api from "../../../Services/api";
import theme from "../../../Styles/theme";
import { app_base_url, baseUrlApiNotoficacoes } from "../../../Utils/baseUrl";
import { isRural } from "../../../Utils/isRural";
import { Alert } from "../../Error/Alert";
import { ModalDivX } from "../../ModalDivX";
import { ModalLoader } from "../../ModalLoader";
import { IAdquirinte } from "../Adquirinte";
import { ITransmitente } from "../Transmitente";
import { Button, Container, Item, Lista, Span, Title } from "./styles";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel: IImovelFocus;
  adquirinte: IAdquirinte;
  transmitente: ITransmitente;
}

export function EnviarImovel({
  open,
  onClose,
  imovel,
  transmitente,
  adquirinte,
}: Props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const { cartorioIsLogged, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  async function execute() {
    try {
      if (cartorioIsLogged) {
        await checarToken();
      }

      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      }

      setLoading(true);

      const { data } = await api.patch(
        `/imovel${isRural() ? "-rural" : ""}/enviar/${imovel.ID}`
      );
     
    } catch (error) {
      setError({
        message:
          "Não foi possível enviar o ímovel para avaliação, tente novamente mais tarde!",
        title: "Ops",
      });
    } finally {
      setLoading(false);
      onClose();

      navigate(`${app_base_url}/imoveis`);
    }
  }

  function renderIcon(check: boolean) {
    if (check) {
      return <Check size={"max(1.2vw, 10px)"} color={theme.colors.success} />;
    } else {
      return <X size={"max(1.2vw, 10px)"} color={theme.colors.attention} />;
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        {transmitente.ID && adquirinte.ID && imovel.ID ? (
          <>
            <Title>
              Tem certeza que deseja enviar o imóvel para avaliação?
            </Title>
            <Span>
              Após o envio não será possível fazer nenhuma edição ou alteração
              de dados!
            </Span>

            <Button onClick={execute}>ENVIAR IMÓVEL PARA AVALIAÇÃO</Button>
          </>
        ) : (
          <>
            <Title>
              Para enviar o imóvel, todos os requisitos abaixo devem ser
              preenchidos:
            </Title>
            <Lista>
              <Item>Transmitente {renderIcon(!!transmitente.ID)}</Item>
              <Item>Adquirinte {renderIcon(!!adquirinte.ID)}</Item>
              <Item>Dados do Imóvel {renderIcon(!!imovel.ID)}</Item>
            </Lista>
          </>
        )}
      </Container>

      <ModalLoader loading={loading} />
      <Alert
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
        message={error.message}
        title={error.title}
      />
    </Modal>
  );
}
